import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ScrollToTop } from './components/common';
import { Clientele, Enquiry, GalleryV2, Home, Performances, Photos, Recordings, Shows } from './pages';

/**
 * Main App Component
 * Handles routing and renders pages
 */
function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen-safe bg-background-darker">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shows" element={<Shows />} />
          <Route path="/enquiry" element={<Enquiry />} />
          <Route path="/videos" element={<GalleryV2 />} />
          <Route path="/photos" element={<Photos />} />
          <Route path="/clientele" element={<Clientele />} />
          <Route path="/live" element={<Performances />} />
          <Route path="/recordings" element={<Recordings />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
